const state = {
  all: []
};

export default state;